import { useEffect, useState } from 'react';

import { CKEditor } from 'ckeditor4-react';

export default function CkEditor({ value, onChange }) {

  const [initData, setInitData] = useState(null);

  useEffect(() => {
    if (initData) {
      onChange({ value: initData });
    }
  }, [initData]); // eslint-disable-line react-hooks/exhaustive-deps

  return <CKEditor
    initData={value}
    onChange={({ editor }) => setInitData(editor.getData())}
    config={{
      allowedContent: true, // ✅ Cho phép toàn bộ nội dung HTML và CSS
    }}
  />
}